@use "../../../sass/global/global" as *;

$border-color: #cdcdcd;

.ux-iws-nav-burger {
    height: 50px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        transform: translate(0, -7px);
    }

    &__open,
    &__close {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0;
        border: 0 solid transparent;
        background: none;
        outline: none;
        box-shadow: none;
        text-shadow: none;
        cursor: pointer;

        ux-icon {
            margin-left: 10px;
            color: $color-grey-3;
            fill: currentColor;
            transition: fill 0.2s ease-in-out;
        }
    }

    &__open {
        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: none;
        }

        ux-icon {
            font-size: 26px;
        }
    }

    &__close {
        display: none;

        ux-icon {
            font-size: 16px;
        }
    }

    .ux-iws-nav-burger__text {
        @include font(bold);
        font-size: $size-text-smaller;
        color: $color-grey-3;
        text-transform: uppercase;
        line-height: normal;
        transition: color 0.2s ease-in-out;
        padding-left: 10px;
    }
}

@media only screen and (min-width: $desktop-s-navigation-100) {
    .ux-iws-nav-burger__close ux-icon {
        font-size: 20px;
    }
}

.ux-iws-nav-burger:hover {
    .ux-iws-nav-burger__text {
        color: $color-green;
    }

    ux-icon {
        color: $color-green;
    }
}

.ux-iws-nav-burger--active {
    .ux-iws-nav-burger__open {
        display: none;
    }

    .ux-iws-nav-burger__close {
        display: flex;
    }
}
